export default __webpack_public_path__ + "static/media/documentation.9b773ef4.svg";